export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div
          className="relative bg-gradient-to-br from-primary-500 via-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 text-center overflow-hidden"
        >
          {/* Decorative */}
          <div className="absolute top-0 right-0 w-[200px] h-[200px] rounded-full bg-background-50/10 blur-2xl pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-[150px] h-[150px] rounded-full bg-background-50/10 blur-2xl pointer-events-none"></div>

          <div className="relative z-10">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-background-50/20 flex items-center justify-center">
              <i className="ri-mail-send-line text-background-50 text-2xl"></i>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-background-50 mb-3">
              投稿与合作
            </h2>
            <p className="text-background-50/85 text-sm md:text-base max-w-[550px] mx-auto mb-8 leading-relaxed">
              如果你有好的综艺节目推荐、原创视频内容，或者希望与天天影视进行商务合作，欢迎通过以下方式联系我们。我们重视每一份来稿和合作意向，期待与你一起打造更好的综艺观看平台。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <div className="flex items-center gap-2 bg-background-50/20 backdrop-blur-sm rounded-full px-6 py-3">
                <i className="ri-mail-line text-background-50 text-lg"></i>
                <span className="text-background-50 text-sm">contact@tiantiantv.com</span>
              </div>
              <div className="flex items-center gap-2 bg-background-50/20 backdrop-blur-sm rounded-full px-6 py-3">
                <i className="ri-wechat-line text-background-50 text-lg"></i>
                <span className="text-background-50 text-sm">天天影视官方微信</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}